"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const stockpile_style_1 = __importDefault(require("../stockpile.style"));
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const stockpile_column_1 = require("../stockpile.column");
const grid_1 = __importDefault(require("components/templates/grid"));
const svg_1 = require("components/atoms/svg");
const modal_1 = require("components/molecules/modal");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const AdjustmentStockpileUploadHistory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isLoadingHistory, mutationMode, dataItemHistory, dataGridHistory, dataStatesHistory } = (0, store_1.useAppSelector)(state => state.adjustment.stockpile);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    (0, react_1.useEffect)(() => {
        if (isLoadingHistory) {
            dispatch(stockpile_action_1.default.getDataGridHistory(dataStatesHistory));
        }
    }, [isLoadingHistory]);
    const onFilterChangeHistory = (e) => {
        dispatch(stockpile_action_1.default.onFilterChangeHistory(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { filter: e.filter });
        dispatch(stockpile_action_1.default.getDataGridHistory(newDataStates));
    };
    const onSortChangeHistory = (e) => {
        dispatch(stockpile_action_1.default.onSortChangeHistory(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { sort: e.sort });
        dispatch(stockpile_action_1.default.getDataGridHistory(newDataStates));
    };
    const onDataStateChangeHistory = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { skip: types === 'page' ? (val - 1) * dataStatesHistory.take : 0, take: types === 'take' ? val : dataStatesHistory.take });
        dispatch(stockpile_action_1.default.onDataStateChangeHistory(newDataStates));
    };
    const columnsRender = stockpile_column_1.UploadHistoryColumnProps.map(item => {
        if (item.field === 'action') {
            return Object.assign(Object.assign({}, item), { cell: (0, custom_cell_grid_1.actionCell)([
                    {
                        type: 'other',
                        permission: true,
                        icon: (0, jsx_runtime_1.jsx)(svg_1.DownloadDocIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
                        onClick: dataItem => dataItem.status == 'Success' ? window.open(dataItem.filepath, '_blank') : '',
                    }
                ]) });
        }
        else if (item.field === 'log_message') {
            return Object.assign(Object.assign({}, item), { cell: (0, custom_cell_grid_1.customLogsCell)({
                    type: 'other',
                    permission: true,
                    onClick: dataItem => {
                        dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: 'upload_logs', dataItemHistory: dataItem }));
                    }
                }) });
        }
        else if (item.field === 'status') {
            return Object.assign(Object.assign({}, item), { cell: custom_cell_grid_1.customStatusCell });
        }
        return item;
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [mutationMode === 'upload_logs' && ((0, jsx_runtime_1.jsx)(modal_1.ModalLog, { appTheme: appTheme, show: mutationMode === 'upload_logs', onClose: () => dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: 'upload_history' })), dataLog: dataItemHistory })), mutationMode === 'upload_history' && ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'Export History', isLoading: isLoadingHistory, isRefresh: true, handleRefresh: () => dispatch(stockpile_action_1.default.onClickMutation({ isLoadingHistory: true, mutationMode: mutationMode })), show: mutationMode === 'upload_history', style: stockpile_style_1.default.modalContainerDeletedList(appTheme), handleClose: () => dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: false })) }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { sortable: true, pageable: false, cardGrid: false, scrollable: 'scrollable', columns: columnsRender, dataGrid: dataGridHistory, sort: dataStatesHistory.sort, dataStates: dataStatesHistory, onSortChange: onSortChangeHistory, style: stockpile_style_1.default.gridHeightDeletedList, onFilterChange: onFilterChangeHistory, onPageChange: (v) => onDataStateChangeHistory('page', v), onTakeChange: (v) => onDataStateChangeHistory('take', v) }) })))] }));
};
exports.default = AdjustmentStockpileUploadHistory;
